import { useCallback, useState } from "react";

import { BTLoading } from "commonComponents/utilities/BTLoading/BTLoading";

export const ResizableJobPickerLoading: React.FunctionComponent = () => {
    const [isNarrow, setIsNarrow] = useState(false);
    const measureRef = useCallback((node: HTMLDivElement | null) => {
        if (node) {
            setIsNarrow(node.clientWidth < 100);
        }
    }, []);
    return (
        <div
            ref={measureRef}
            className="ResizableJobPickerLoading"
            data-testid="ResizableJobPickerLoading"
        >
            {isNarrow ? (
                <div className="CollapsedLoading" data-testid="CollapsedLoading" />
            ) : (
                <BTLoading displayMode="absolute" data-testid="JobPickerLoading" />
            )}
        </div>
    );
};
